import { auth } from '@/firebaseConfig';
import { getIdToken, getIdTokenResult, onIdTokenChanged } from 'firebase/auth';
import { useEffect, useState } from 'react';
import ObjectFieldsSection from './ObjectFieldsSection';

interface TokenInfo {
  uid: string;
  tenantId?: string;
  email?: string;
  auth_time?: string;
  iat?: string;
  exp?: string;
  tokenPreview?: string;
}

const FirebaseTokenSection = ({ opened }: { opened: boolean }) => {
  const [tokenInfo, setTokenInfo] = useState<TokenInfo>();

  useEffect(() => {
    if (!opened) {
      setTokenInfo(undefined);
      return;
    }

    const update = async (force: boolean) => {
      try {
        const user = auth.currentUser;
        if (!user) {
          setTokenInfo(undefined);
          return;
        }
        const [idToken, result] = await Promise.all([
          getIdToken(user, force),
          getIdTokenResult(user),
        ]);
        const claims: any = result.claims ?? {};
        const toLocal = (sec: any) =>
          Number.isFinite(Number(sec))
            ? new Date(Number(sec) * 1000).toLocaleString()
            : undefined;
        setTokenInfo({
          uid: user.uid,
          tenantId: user.tenantId ?? undefined,
          email: user.email ?? undefined,
          auth_time: toLocal(claims.auth_time),
          iat: toLocal(claims.iat),
          exp: toLocal(claims.exp),
          tokenPreview: idToken
            ? `${idToken.slice(0, 12)}...${idToken.slice(-8)}`
            : undefined,
        });
      } catch (error) {
        setTokenInfo(undefined);
        console.error('Failed to load Firebase token', error);
      }
    };

    const unsub = onIdTokenChanged(auth, () => {
      update(false);
    });
    update(false);
    return () => unsub();
  }, [opened]);

  return (
    <ObjectFieldsSection document={tokenInfo} title='Firebase Auth Token' />
  );
};

export default FirebaseTokenSection;
